import React from "react";
import { useNavigate } from "react-router-dom";
import cashCar from "../../assets/cash-car.png";
import usedCar from "../../assets/used-car.png";
import newBike from "../../assets/new-bike.png";
import newLoan from "../../assets/new-loan.png";
import styles from "./LoanOfferComponent.module.css";
import OurPartners from "../../components/OurPartners";

function LoanOfferComponent() {
  const navigate = useNavigate();

  return (
    <div className={styles.mainContainer}>
      <div className={styles.container}>
        {/* Explore VAAHANBUDDY section */}
        <div className={styles.exploreContainer}>
          <h2 className={styles.exploreTitle}>Explore VAAHANBUDDY</h2>

          <div className={styles.cardGrid}>
            {/* Cash on Car */}
            <div className={styles.cardWrapper}>
              <div className={styles.card}>
                <div className={styles.cardHeader}>Cash on Car</div>
                <div className={styles.cardBody}>
                  <p className={styles.cardText}>
                    Get 1% Cashback and 2x the Money against your Existing Car
                  </p>
                  <div className={styles.cardImageContainer}>
                    <img
                      src={cashCar}
                      alt="Cash on Car"
                      className={styles.cardImage}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Used Car Loan */}
            <div className={styles.cardWrapper}>
              <div className={styles.card}>
                <div className={styles.cardHeader}>Used Car Loan</div>
                <div className={styles.cardBody}>
                  <p className={styles.cardText}>
                    Exciting Deals on Pre-owned Cars
                  </p>
                  <div className={styles.cardImageContainer}>
                    <img
                      src={usedCar}
                      alt="Used Car Loan"
                      className={styles.cardImage}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* New Bike Loan */}
            <div className={styles.cardWrapper}>
              <div className={styles.card}>
                <div className={styles.cardHeader}>New Bike Loan</div>
                <div className={styles.cardBody}>
                  <p className={styles.cardText}>
                    Get New Bike Loan on Any Brand
                  </p>
                  <div className={styles.cardImageContainer}>
                    <img
                      src={newBike}
                      alt="New Bike Loan"
                      className={styles.cardImage}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* New Car Loan */}
            <div className={styles.cardWrapper}>
              <div className={styles.card}>
                <div className={styles.cardHeader}>New Car Loan</div>
                <div className={styles.cardBody}>
                  <p className={styles.cardText}>
                    Exciting Deals on Pre-owned Cars
                  </p>
                  <div className={styles.cardImageContainer}>
                    <img
                      src={newLoan}
                      alt="New Car Loan"
                      className={styles.cardImage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OurPartners />
    </div>
  );
}

export default LoanOfferComponent;